import { Inject, Injectable } from '@angular/core';
import { AuthService } from "@services/auth/auth.service";
import { UserData } from '@shared/models/user-data.model';
import { mergeMap, Observable } from 'rxjs';
import { OidcSecurityService } from "angular-auth-oidc-client";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AuthOidcService extends AuthService {

  constructor(
    @Inject('TOKEN_ENDPOINT') private tokenEndpoint: string,
    @Inject('AUTH_APP_ID') private appId: string,
    private httpClient: HttpClient,
    private oidcSecurityService: OidcSecurityService,
  ) {
    super();
  }

  get isAuthenticated$(): Observable<boolean> {
    return this.oidcSecurityService.isAuthenticated$.pipe(
      map(isAuthenticated => {
        return isAuthenticated.isAuthenticated;
      })
    );
  }

  get userData$(): Observable<UserData> {
    return this.oidcSecurityService.userData$.pipe(
      map(userDataResult => {
        return this.mapUserData(userDataResult.userData)
      })
    )
  }

  public override login(): void {
    this.oidcSecurityService.authorize()
  }

  public override logout(): void {
    this.oidcSecurityService.logoffLocal()
  }

  public override getAccessToken(): Observable<string> {
    return this.oidcSecurityService.getAccessToken();
  }


  public override getIdToken(): Observable<string> {
    return this.oidcSecurityService.getIdToken();
  }

  public override getRefreshToken(): Observable<string> {
    return this.oidcSecurityService.getRefreshToken();
  }

  public override getMSGraphAccessToken(): Observable<string> {
    return this.oidcSecurityService.getRefreshToken().pipe(
      mergeMap(refresh => {
        let body = this.createRequestBody(refresh);
        let options = this.getHeaders();
        return this.httpClient.post<any>(this.tokenEndpoint, body.toString(), options)
      }),
      map(response => {
        return response.access_token;
      })
    )
  }

  public override checkAuth(): Observable<{ isAuthenticated: boolean; userData: UserData | undefined; }> {
    return this.oidcSecurityService.checkAuth().pipe(
      map((authResult) => {
        return {
          isAuthenticated: authResult.isAuthenticated,
          userData: authResult.userData ? this.mapUserData(authResult.userData) : undefined
        };
      })
    );
  }

  private mapUserData(userData: any): UserData {
    return new UserData(
      userData.oid,
      userData.tid,
      userData.name,
      userData.email,
      userData.roles
    );
  }

  private getHeaders() {
    return {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "application/json, text/plain, */*",
      }
    };
  }

  private createRequestBody(refresh: string) {
    let body = new URLSearchParams();
    body.set('grant_type', 'refresh_token')
    body.set('client_id', this.appId)
    body.set('refresh_token', refresh)
    body.set('scope', 'https://graph.microsoft.com/.default')
    return body;
  }


}
